module.exports = __webpack_public_path__ + "images/8c1b21a59011cb66b3c9c0c4808ac36d.svg";